/* ============================================================
   assets/int-reveal-lead.js                 INTENTION — 2026-09-03
   THE REVEAL HEADLINE. One implementation, both templates, every width.

   "The Story continues..." and "Into Philanthropy?" — the two wiped-in lines
   that open the reading half and the Circle.

   ⚑ WHERE IT CAME FROM. makeLead() existed TWICE, once in
   assets/int-pdp-mobile.js and once in assets/int-fp-mobile.js, and the
   framed print copy's own comment admitted it was "lifted from" the apparel
   one. Both files return above 820px, so the headlines existed on phones and
   nowhere else. Nils asked for them on desktop too, on both templates, so the
   duplicate had to become one file that is not width gated. Third extraction
   of this shape today, after assets/int-zoom.js and
   assets/int-size-select.js.

   ⚑ CALLERS PASS THE ORDER. Both product columns are `order`-driven, and an
   element without an order computes 0 and lands above the title — two
   headlines appeared up there once. Mobile passes its own numbers, desktop
   passes the ones in assets/int-pdp-desktop.css.

   ⚑ THE 300s BACKSTOP IS DELIBERATE. 8s, then 45s, both fired before a real
   reader ever arrived, so the TIMER drew the line and the animation was never
   seen. What reveals these in a real browser is the IntersectionObserver plus
   the scroll listener; the timer only stops a page where both failed from
   leaving a headline invisible. Do not lower it. The same number is in
   snippets/int-clara-signature.liquid and assets/int-brand-quote.js.

   ⚑ THE STYLING IS NOT HERE. `.int-story-lead` is drawn by
   assets/int-pdp-mobile.css under `.int-mob-order`, by
   assets/int-fp-mobile.css under `body.int-fp-order`, and on desktop by
   assets/int-pdp-desktop.css. Three homes because three columns.
   ============================================================ */
(function () {
  'use strict';
  if (window.__intMakeLead) return;

  function makeLead(text, beforeEl, extraClass, order) {
    if (!beforeEl || !beforeEl.parentNode) return null;

    var el = document.createElement('p');
    el.className = 'int-story-lead' + (extraClass ? ' ' + extraClass : '');
    el.appendChild(document.createElement('span')).textContent = text;
    if (order) el.style.order = order;
    beforeEl.parentNode.insertBefore(el, beforeEl);

    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    if (!reduce) el.classList.add('is-armed');

    var shown = false;
    function show() { if (!shown) { shown = true; el.classList.add('is-in'); } }
    /* Well into view, not merely peeking over the fold. */
    function inView() {
      var r = el.getBoundingClientRect();
      return r.top < window.innerHeight * 0.72 && r.bottom > 0;
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          if (es[i].isIntersecting) { show(); io.disconnect(); }
        }
      }, { threshold: 1, rootMargin: '0px 0px -22% 0px' });
      io.observe(el);
    }
    window.addEventListener('scroll', function () { if (inView()) show(); }, { passive: true });
    setTimeout(function () { if (inView()) show(); }, 1200);
    setTimeout(show, 300000);
    return el;
  }

  window.__intMakeLead = makeLead;

  /* ── DESKTOP CALLER ────────────────────────────────────────────────────
     Below 821px the two template scripts place their own leads, because they
     also own the mobile order. Above it neither of them runs at all, so the
     headlines are built here.

     ⚑ The anchors are only where the element is INSERTED; where it APPEARS is
     decided by the order value, exactly as on mobile. Anything inside
     .product__inner will do. */
  function mountDesktop() {
    try {
      if (!window.matchMedia || !window.matchMedia('(min-width: 821px)').matches) return;
    } catch (e) { return; }

    var inner = document.querySelector('.product__inner');
    if (!inner) return;
    if (inner.querySelector('.int-story-lead')) return;

    /* ⚑ THE TWO DESKTOP COLUMNS ARE NOT THE SAME KIND OF COLUMN.
       Apparel's is an ORDERED flex column (assets/int-pdp-desktop.css), so
       the lead can be inserted anywhere and placed by its order value.
       Framed print's desktop column is the theme's ordinary block flow —
       there is no order layer up here — so an order value does nothing and
       the lead simply sits where it is inserted. Measured before this split:
       on framed print desktop the headline landed at y=201, up beside the
       title, because `order: 140` was ignored.
       So: apparel places by order, framed print places by anchor. */
    var isFramedPrint = document.body.classList.contains('int-frame-color-product');

    if (isFramedPrint) {
      /* "THIS PIECE CARRIES" is the top of the reading half on this
         template, so the headline opens it. */
      var fpAnchor = inner.querySelector('.int-teasers')
                  || inner.querySelector('.int-product-reviews');
      if (fpAnchor) makeLead(((window.INT_JS_I18N||{}).story)||'The Story continues...', fpAnchor);
    } else {
      var storyAnchor = inner.querySelector('.product__subtitle')
                     || inner.querySelector('.product-organic-certification')
                     || inner.querySelector('.int-teasers');
      if (storyAnchor) makeLead(((window.INT_JS_I18N||{}).story)||'The Story continues...', storyAnchor, null, 140);
    }

    /* opens the Circle. Same anchor on both templates; the order value is
       harmless where there is no ordered column. */
    var circle = inner.querySelector('.int-circle-note');
    if (circle) makeLead(((window.INT_JS_I18N||{}).philanthropy)||'Into Philanthropy?', circle, 'int-story-lead--circle', isFramedPrint ? null : 190);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountDesktop);
  } else {
    mountDesktop();
  }
})();
